import { render, staticRenderFns } from "./activityReview.vue?vue&type=template&id=22fa915d&scoped=true"
import script from "./activityReview.vue?vue&type=script&lang=js"
export * from "./activityReview.vue?vue&type=script&lang=js"
import style0 from "./activityReview.vue?vue&type=style&index=0&id=22fa915d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa915d",
  null
  
)

export default component.exports